import { Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutlined } from '@ant-design/icons';
import NewLogo from "../../assests/images/collab_ai_logo_white.svg"
import "./Review.css"

const { Title, Text } = Typography;
const AccountReview = () => {
    const navigate = useNavigate();

    return (
        <div className="review-container">
            <div className="logo-container" onClick={() => navigate('/login')}>
                <img src={NewLogo} alt="App Logo" className="logo" />
            </div>

            <div className="review-card">
                <CheckCircleOutlined className="review-icon" />

                <Title level={4} className="title">Account Under Review</Title>

                <Text className="description">
                    Thank you for signing up! Our team is reviewing your account, and we will notify you once it's approved.
                </Text>

                <Button type="primary" block onClick={() => navigate('/login')} className="login-btn">
                    Go to Login
                </Button>
            </div>
        </div>
    );
};

export default AccountReview;